export default __webpack_public_path__ + "static/media/qualidade.615f0230.png";